export const PRIORITY_HIGH = 1;
export const PRIORITY_MEDIUM = 2;
export const PRIORITY_LOW = 3;

export default [
    {
        id: PRIORITY_HIGH,
        descripcion: "Alta",
        peso: PRIORITY_HIGH,
        css: 'danger'
    },
    {
        id: PRIORITY_MEDIUM,
        descripcion: "Media",
        peso: PRIORITY_MEDIUM,
        css: 'warning'
    },
    {
        id: PRIORITY_LOW,
        descripcion: "Baja",
        peso: PRIORITY_LOW,
        css: 'primary'
    }
]